import { ff } from '@atlassian/jira-feature-flagging';
import { ASSIGNEE_TYPE, PRIORITY_TYPE } from '@atlassian/jira-platform-field-config';

export const getSoftRefreshSupportedFields = (): string[] => {
	const fields: string[] = [];
	if (ff('relay-migration-issue-fields-assignee-ld')) {
		fields.push(ASSIGNEE_TYPE);
	}
	if (ff('relay-migration-issue-fields-priority_ri9vi')) {
		fields.push(PRIORITY_TYPE);
	}
	return fields;
};
